import React from "react"
import PropTypes from "prop-types"
import * as styles from "./MultiRowTable-tw-styles"
import { get } from "../../helpers/utils"
import Typography from "../UI/Typography/Typography"
import ImageWithText from "../ImageWithText/ImageWithText"
import Link from "../UI/Link/Link"
import useScreenSize from "../../hooks/useScreenSize"


const MultiRowTable = props => {
  const {
    heading,
    varient,
    showHeading,
    itemId
  } = props

  const {
    rowHeadingCollection,
    rowCardsCollection
  } = props?.tableJsonData ? props.tableJsonData : props

  const showHeadingInDesktop = showHeading // this heading is for desktop only
  const rowHeading =
    rowHeadingCollection && get(rowHeadingCollection, "items", [])
  const rowData = rowCardsCollection && get(rowCardsCollection, "items", [])
  const style = styles[varient] || styles?.dynamiTableStyles
  const screen = useScreenSize()
  //sort column by spliting
  const getCol = str => str.split("column")[1]
  // column keys
  const column =
    rowData &&
    rowData?.length &&
    Object.keys(
      Object.fromEntries(
        Object.entries(rowData[0]).filter(([_, v]) => v !== null)
      )
    )
      .filter(item => item !== "rowCardHeadingAndDesc")
      ?.sort((a, b) => getCol(a) - getCol(b))

  // heading data
  const thData = () => {
    return rowHeading?.map((heading, index) => (
      <th className={style?.thStyle} key={index}>
        {heading?.title && <Typography content={heading.title} />}
        {heading?.longTitle && <Typography content={heading.longTitle} />}
      </th>
    ))
  }
  const tdDisplay = (data, idx) => {
    if (data?.images) {
      return (
        <td className={style?.tdStyle1} key={idx}>
          {screen?.isMobile &&
            (data?.mainHeading ? (
              <Typography
                className={style?.mobileHeading}
                content={data?.mainHeading}
              />
            ) : (
              rowHeading && (
                <Typography
                  className={style?.mobileHeading}
                  content={rowHeading[idx]?.title}
                />
              )
            ))}
          <ImageWithText {...data} />
        </td>
      )
    } else if (data?.variant == "ICON_WITH_LABEL") {
      return (
        <td className={style?.tdStyle1} key={idx}>
          <Typography content={data.label} className={style?.tablePara} />
        </td>
      )
    } else if (data?.variant == "COLUMN_WITH_ICON") {
      return (
        <td className={style?.tdStyle1} key={idx}>
          <p className={style?.iconClassWarp}>
            <span className={data?.iconClass}></span>
          </p>
        </td>
      )
    } else {
      return (
        <td className={style?.tdStyle1} key={idx}>
          {screen?.isMobile &&
            data?.variant != "MULTI_ROW_TABLE_WITH_ICON" &&
            (data?.mainHeading ? (
              <Typography
                content={data?.mainHeading}
                className={style?.mobileHeading}
              />
            ) : (
              rowHeading && (
                <Typography
                  content={rowHeading[idx]?.title}
                  className={style?.mobileHeading}
                />
              )
            ))}
          {data?.heading && data?.headingIsLink ? (
            <Link {...data?.link}>
              <Typography content={data?.heading} />
            </Link>
          ) : data?.heading == "+" ? (
            <div>
              <img width="28" height="28" alt="Alternate Member" aria-label="Alternate Member" src="https://images.ctfassets.net/zo243s55pyir/2T0HlUbABCWGpmHsFfqJ1/d31366e261e82b5db78eeedb000cc95e/plus.256x256.png"/>
            </div>
          ) : (
            <Typography content={data?.heading} />
          )}
          {data?.description === "-" ? (
            <p>-</p>
          ) : (
            <Typography content={data?.description} allow_br_tag={true} />
          )}
          {data?.categoryLinksCollection?.items.length > 0 &&
            data.categoryLinksCollection.items.map((link, index) => {
              return <Link key={index} {...link} />
            })}
        </td>
      )
    }
  }
  // column data
  const tdData = () => {
    return rowData?.map((data, index) => (
      <React.Fragment key={index}>
        {data.rowCardHeadingAndDesc && (
          <Typography
            component="tr"
            content={data.rowCardHeadingAndDesc}
            className={style?.tdStyDIV}
          />
        )}
        <tr className={style?.tdStyle} key={index}>
          {column?.map((key, idx) => {
            return tdDisplay(data[key], idx)
          })}
        </tr>
      </React.Fragment>
    ))
  }

  return (
    <div id={itemId} className={style?.tableWrpr}>
      {heading && showHeadingInDesktop && (
        <h2 className={style?.tableTitle}>{heading}</h2>
      )}
      <div className={style?.tableResponsive}>
        <table className={style?.tableContainer}>
          <thead className={style?.tableWarp_thead}>
            <tr className={style?.thDataWrpr}>{thData()}</tr>
          </thead>
          <tbody className={style?.tableWarp_tbody}>{tdData()}</tbody>
        </table>
      </div>
    </div>
  )
}

MultiRowTable.propTypes = {
  rowHeadingCollection: PropTypes.object,
  rowCardsCollection: PropTypes.object,
  rowData: PropTypes.array,
  heading: PropTypes.string,
  varient: PropTypes.string,
  showHeading: PropTypes.bool,
  itemId: PropTypes.string,
  tableJsonData: PropTypes.object,
}

export default MultiRowTable
